import { useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export default function () {
    var ref = useRef(null); // The ref is used to measure the size of the element
    var _a = useState({
        height: 0,
        left: 0,
        top: 0,
        width: 0,
    }), bounds = _a[0], setBounds = _a[1];
    var resizeObserver = useState(function () {
        return new ResizeObserver(function (_a) {
            var entry = _a[0];
            setBounds(entry.contentRect);
        });
    })[0];
    useEffect(function () {
        if (ref && ref.current) {
            resizeObserver.observe(ref.current);
        }
        return function () { return resizeObserver.disconnect(); };
    }, []);
    return [ref, bounds];
}
//# sourceMappingURL=index.js.map